import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { UnitDocumentItem } from './UnitDocumentItem';

export interface UnitDocumentsAccordionProps {
  /** ADHA project documents (brochure / master plan). */
  documents: ReadonlyArray<{
    id: string;
    title: string;
    url?: string;
    urls?: ReadonlyArray<string>;
    action?: 'download' | 'view';
    actionLabel?: string;
  }>;
  onDocumentPress?: (documentId: string) => void;
  downloadingDocumentId?: string | null;
}

/**
 * Documents section — white card wrapping optional brochure / master plan rows.
 * Hidden entirely when neither document is present.
 */
export function UnitDocumentsAccordion({
  documents,
  onDocumentPress,
  downloadingDocumentId = null,
}: Readonly<UnitDocumentsAccordionProps>) {
  const colors = useUIColors();

  const visibleDocuments = documents.filter((document) => {
    if (document.action === 'view') {
      return Boolean(document.url?.trim());
    }
    if (document.urls?.some((url) => Boolean(url?.trim()))) {
      return true;
    }
    return Boolean(document.url?.trim());
  });

  if (visibleDocuments.length === 0) {
    return null;
  }

  return (
    <View style={[styles.card, { backgroundColor: colors.white }]}>
      <View style={styles.documentsList}>
        {visibleDocuments.map((document) => (
          <UnitDocumentItem
            key={document.id}
            title={document.title}
            action={document.action === 'view' ? 'view' : 'download'}
            {...(document.actionLabel
              ? { actionLabel: document.actionLabel }
              : {})}
            isDownloading={downloadingDocumentId === document.id}
            onPress={() => onDocumentPress?.(document.id)}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 12,
    padding: 16,
    overflow: 'hidden',
  },
  documentsList: {
    gap: 8,
  },
});

export default UnitDocumentsAccordion;
